import React from 'react'
import Icon from 'react-icon-base'

const Workhistory = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g id="Workhistory" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Workhistory" transform="translate(-126.000000, -3132.000000)">
        <rect id="Rectangle" fill="#F1F1F1" x="0" y="8" width="1200" height="3822" />
        <g id="Group" transform="translate(32.000000, 410.000000)" />
        <g id="Group-7" transform="translate(32.000000, 3007.000000)">
          <rect id="Rectangle-Copy" stroke="#DDDDDD" fill="#FFFFFF" x="0.5" y="0.5" width="1135" height="325" rx="4" />
          <g id="Group-19" transform="translate(24.000000, 125.000000)" stroke="#3498DB" strokeWidth="2">
            <g id="Group" transform="translate(70.000000, 0.000000)">
              <rect
                id="Rectangle"
                transform="translate(15.500000, 16.500000) rotate(90.000000) translate(-15.500000, -16.500000) "
                x="5"
                y="2"
                width="21"
                height="29"
                rx="1.87878788"
              />
              <line x1="2.46666667" y1="7.45454545" x2="15.5" y2="16.5" id="Line" strokeLinecap="round" />
              <line
                x1="15.5"
                y1="6.5"
                x2="29.5333333"
                y2="16.5454545"
                id="Line-Copy"
                strokeLinecap="round"
                transform="translate(22.500000, 11.500000) scale(1, -1) translate(-22.500000, -11.500000) "
              />
              <path
                d="M21.1212121,1 C21.3638827,1 21.5835797,1.09836168 21.742609,1.25739101 C21.9016383,1.41642034 22,1.63611731 22,1.87878788 L22,1.87878788 L22,6 L9,6 L9,1.87878788 C9,1.63611731 9.09836168,1.41642034 9.25739101,1.25739101 C9.41642034,1.09836168 9.63611731,1 9.87878788,1 L9.87878788,1 L21.1212121,1 Z"
                id="Rectangle"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
)

Workhistory.defaultProps = {
  size: 30
}

export default Workhistory
